import { render } from "./ContentSuggestForm.vue?vue&type=template&id=f722bce0&scoped=true"
import script from "./ContentSuggestForm.vue?vue&type=script&lang=js"
export * from "./ContentSuggestForm.vue?vue&type=script&lang=js"

import "./ContentSuggestForm.vue?vue&type=style&index=0&id=f722bce0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f722bce0"]])

export default __exports__